import { ModelImage } from '../model-image';
import { User } from '../../shared';
import { Device } from '../device';
import { Resource } from '../resource';
import {ApplicationArtatech} from '../application/application-artatech.model';
export class Seller {
    constructor(
        public id?: number,
        public name?: string,
        public tutorialPackage?: string,
        public tutorialParam?: string,
        public libraryMode?: boolean,
        public cleanApplications?: boolean,
        public createDate?: any,
        public lastModifiedDate?: any,
        public layout?: any,
        public shutdown?: ModelImage,
        public owner?: User,
        public devices?: Device,
        public files?: Resource[],
        public screensaver?: ModelImage,
        public applications?: ApplicationArtatech,
    ) {
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/seller/seller.model.ts